import { howItWorks } from "@/mocks/archiveEntries";

const HowItWorks = () => {
  return (
    <section className="w-full bg-background-100 py-16 md:py-24">
      <div className="mx-auto w-full max-w-[1240px] px-4 md:px-6">
        <div className="max-w-2xl">
          <span className="reveal inline-flex items-center gap-2 text-xs font-medium tracking-[0.24em] text-primary-600">
            <span className="h-px w-8 bg-primary-400" />
            检索方式
          </span>
          <h2 className="reveal mt-5 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-4xl">
            三步完成一次留档回看
          </h2>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-6 md:mt-14 md:grid-cols-3 md:gap-8">
          {howItWorks.map((step, index) => (
            <div
              key={step.step}
              className="reveal relative flex flex-col rounded-lg border border-background-300 bg-background-50 p-7 md:p-8"
            >
              <span className="absolute right-6 top-6 font-heading text-4xl font-bold text-background-300 md:text-5xl">
                {step.step}
              </span>
              <span className="flex h-14 w-14 items-center justify-center rounded-md bg-primary-100 text-2xl text-primary-600">
                <i className={step.icon} />
              </span>
              <h3 className="mt-6 font-heading text-lg font-bold text-foreground-950 md:text-xl">
                {step.title}
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600">{step.desc}</p>
              {index < howItWorks.length - 1 && (
                <span className="mt-6 inline-flex items-center gap-2 text-xs tracking-wide text-foreground-400 md:mt-8">
                  <i className="ri-arrow-right-line" />
                  下一步
                </span>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;